import React from 'react';
import Hero from '../Components/Hero';
import PizzasProducts from '../Components/PizzasProducts';
import DrinksProducts from '../Components/DrinksProducts';
import DessertsProducts from '../Components/DessertsProducts';
import Footer from '../Components/Footer';
import SpecialOfTheDay from '../Components/SpecialOfTheDay';
import { FaShoppingCart as Icon } from 'react-icons/fa';
import { NavLink } from 'react-router-dom';

function Home() {
    return (
        <div>
            <Hero />
            <div className='icon__section'>
                <NavLink to='/cart'>
                    <Icon className='icon__cart' />
                </NavLink>
            </div>
            <PizzasProducts />
            <div class='pizza-logo'></div>
            <DrinksProducts />
            <SpecialOfTheDay />
            <DessertsProducts />
            <div class='pizza-logo-two'></div>
            <Footer />
        </div>
    );
}

export default Home;
